export const mobileNavPaths = [
  "/dashboard",
  "/resources",
  "/profile",
  "/training",
  "/index"
];
